@if (
  {
    deliveryItems: deliveryItems$ | async,
    savedInstallationReportsResponse: savedInstallationReportsResponse$ | async,
  };
  as combinedData
) {
  @if (
    combinedData.deliveryItems?.isLoading ||
    combinedData.savedInstallationReportsResponse?.isLoading
  ) {
    <ipo-loading-spinner></ipo-loading-spinner>
  }
  @if (
    combinedData.deliveryItems?.data &&
    combinedData.savedInstallationReportsResponse?.data
  ) {
    <app-hc-table
      [ifs]="ifs"
      [savedInstallationReportsResponse]="
        combinedData.savedInstallationReportsResponse!
      "
      [installationReports]="combinedData.deliveryItems?.data!"
      [multiPointData]="multiPointData"
      (dismiss)="closeModal()"
    ></app-hc-table>
  }
}
